import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { BdsSwitch } from '@/core/constants/webComponents';
import './TagsIntersectionSwitch.scss';

interface TagsIntersectionSwitchProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
}

export const TagsIntersectionSwitch: React.FC<TagsIntersectionSwitchProps> = ({ checked, onChange, disabled = false }) => {
  const { t } = useTranslation();
  const switchRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const el = switchRef.current;
    if (!el || !onChange) return;

    const handleChange = (event: Event) => {
      const checkedValue = (event as CustomEvent).detail?.checked;
      if (typeof checkedValue === 'boolean') {
        onChange(checkedValue);
      }
    };

    el.addEventListener('bdsChange', handleChange);
    return () => el.removeEventListener('bdsChange', handleChange);
  }, [onChange]);

  return (
    <div className="tags-intersection-switch-wrapper">
      <div className="tags-intersection-switch__content">
        <BdsSwitch
          ref={switchRef as any}
          name="tags-intersection"
          refer="tags-intersection"
          checked={checked}
          size="short"
          disabled={disabled}
        />
        <span className="tags-intersection-switch__label">
          {t('globalFilter.tagsIntersection', 'Interseção de tags')}
        </span>
      </div>
      <span className="tags-intersection-switch__help-text">
        {t('globalFilter.tagsIntersectionTooltip', 'When enabled, returns only publications that contain all selected tags')}
      </span>
    </div>
  );
};
